
import React from 'react';
import { useRecoilValue } from 'recoil';
import { LoggedInState } from '../../states/LoggedIn';
import CustomToaster from '../Common/Toaster/CustomToaster';
import LoggedOut from '../LoggedOut/LoggedOut';
import LoggedIn from '../LoggedIn/LoggedIn';
import { ADMIN_URL } from '../../config';

function Root() {
  const loggedIn = useRecoilValue(LoggedInState)

  if (loggedIn != null) {
    if (loggedIn.user.type === "A" || loggedIn.user.type === "T") {
      window.location.href = ADMIN_URL
      return
    }
  }

  return <div>
    <CustomToaster />
    {loggedIn == null ? <LoggedOut /> : <LoggedIn />}
  </div>
}

export default Root;